"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var operators_1 = require("rxjs/operators");
var skynet_store_manager_1 = require("@synisys/skynet-store-manager");
exports.currencyStoreManager = new skynet_store_manager_1.EntityStoreManager('currencies.currencies', function (item) { return item.id; });
exports.currencyRateStoreManager = new skynet_store_manager_1.EntityStoreManager('currencies.rates', keyExtractor);
function keyExtractor(item) {
    var date = new Date(item.timestamp);
    date.setUTCHours(0, 0, 0, 0);
    return JSON.stringify({
        currencyId: item.currencyId,
        date: date.toISOString().replace('T00:00:00.000Z', ''),
    });
}
exports.keyExtractor = keyExtractor;
function dataExtractor(key) {
    var parsed = JSON.parse(key);
    return {
        timestamp: new Date(parsed.date).getTime(),
        currencyId: parsed.currencyId,
    };
}
exports.dataExtractor = dataExtractor;
function getDefaultCurrency(store) {
    return exports.currencyStoreManager.selectAll(store).pipe(operators_1.filter(function (value) { return !value.isEmpty(); }), operators_1.map(function (currencies) {
        return currencies.valueSeq().find(function (currency) { return currency.isDefault; });
    }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, Error("Can't find default currency")));
}
exports.getDefaultCurrency = getDefaultCurrency;
//# sourceMappingURL=currency.store.js.map